import styles from './Categories.section.module.css'
import { Check, Plus, Trash, X } from 'lucide-react'

import { useState } from 'react'
import { useCategories, useCategoriesMutations } from '../../../../hooks/templates/categories/useCategories'

type Props = {
    selectedCategoryId: number | null
    setSelectedCategoryId: (id: number | null) => void
}

export default function CategoriesSection({selectedCategoryId, setSelectedCategoryId} : Props) {
  
    const {isLoading: isCategoriesLoading, data: categories, isError: isCategoriesError} = useCategories()    
    const {createCategory, /**updateCategory,*/ deleteCategory} = useCategoriesMutations()
    
    const [categoryInput, setCategoryInput] = useState("")
    const [isOpenInput, setOpenInput] = useState(false)
    
    
    const handleCreateCategory = () => {
        if(!categoryInput) return
        createCategory.mutate({name: categoryInput})                
        handleCategoryInputReset()
    }    

    const handleCategoryInputReset = () => {
        setCategoryInput("")
        setOpenInput(false)
    }

    /**const handleUpdateCategory = (id: number) => { 
        if(!categoryInput) return
        updateCategory.mutate({id, data: {name: categoryInput}})
    }*/

    const handleDeleteCategory = (id: number) => {
        if(id === selectedCategoryId) { setSelectedCategoryId(null) }
        deleteCategory.mutate(id)
    }

    const handleCategorySelect = (id: number) => {
        setSelectedCategoryId(selectedCategoryId === id ? null : id)
    }

    const handleCategoryInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if(e.code === "Enter") {
            handleCreateCategory()
        }
    }

    return (           
        <div className={`${styles.categories}`}>
            <div className={styles.nav}>
                <span className={styles.title}>Categorías</span>
                <div className={styles.add}
                    onClick={() => setOpenInput(true)}
                >
                    <Plus />
                </div>
            </div>
            <div className={styles.separatorh}></div>
            {
                isOpenInput && (
                    <div className={styles.itemcreate}>
                        <input 
                            type="text" 
                            placeholder={"Categoria..."}
                            value={categoryInput}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => (setCategoryInput(e.currentTarget.value))}
                            onKeyDown={handleCategoryInputKeyDown}
                            autoFocus
                            
                        />
                        <div className={styles.options}>
                            <div className={styles.option}
                                onClick={(e) => {e.stopPropagation(); handleCategoryInputReset()}}
                            >
                                <X width={16} height={16}/> 
                            </div>
                            <div className={styles.option} 
                                onClick={(e) => {e.stopPropagation(); handleCreateCategory()}}
                            > 
                                <Check width={16} height={16}/> 
                            </div>
                        </div>
                    </div>
                )
            }
            <div className={styles.list}>
                {isCategoriesLoading && <span>Cargando...</span>}
                {isCategoriesError && <span>No se han podido cargar las categorías</span>}                    
                {
                    categories?.map(category => (
                        <div 
                            key={`Category-${category.id}`} 
                            className={`${styles.item} ${selectedCategoryId === category.id ? styles.selected : ""}`}
                            onClick={() => handleCategorySelect(category.id)}
                        >
                            <span>{category.name}</span>
                            <div className={styles.options}>
                                    {/**
                                    <div className={styles.option}
                                        onClick={(e) => {e.stopPropagation();}}
                                    >
                                        <EllipsisVerticalIcon width={16} height={16}/> 
                                    </div>
                                    */}
                                    <div className={styles.option} 
                                            onClick={(e) => {e.stopPropagation(); handleDeleteCategory(category.id)}}
                                    > 
                                        <Trash width={16} height={16}/> 
                                    </div>
                            </div>
                        </div>
                    ))
                }                        
            </div>
        </div>                            
    )
}
